The input parameter for the `deletePositionOpening` mutation.
